import { Link, TableCell, TableRow } from "@mui/material";
import { COLORS } from "../../../../ui/Theme";

const IncrementRow = ({ row }) => {
  return (
    <TableRow key={row.symbol}>
      <TableCell sx={{ textAlign: "center" }}>
        <Link href={row.link} component={"a"} target="_blank">
          {row.symbol}
        </Link>
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>{row.commodity}</TableCell>
      <TableCell sx={{ textAlign: "center", color: COLORS.GREEN }}>
        {row.deviation}%
      </TableCell>
      <TableCell sx={{ textAlign: "center" }}>{row.last_price_date}</TableCell>
    </TableRow>
  );
};

export default IncrementRow;
